<!-- ═══════════════ REUSABLE REPORT HEADER BAR ═══════════════ -->
<div class="report-header">
	<!-- Left: Icon + Title -->
	<div>
		<div class="report-title-row">
			<img [src]="icon" alt="" class="report-icon" />
			<h2 class="report-title">{{ breadcrumb || reportTitle }}</h2>
		</div>
	</div>

	<!-- Right: Action Buttons -->
	<div class="report-header-right">
		<!-- Extra projected content before export buttons -->
		<ng-content select="[header-left-actions]"></ng-content>

		<!-- PDF Download -->
		<button *ngIf="showPdfButton"
			mat-icon-button
			matTooltip="Download to View/Print PDF Report"
			(click)="onPdfExport()"
			[disabled]="pdfDisabled">
			<img src="assets/images/icons/report-download.png"  alt="Download Report" />
		</button>

		<!-- Excel Download -->
		<button *ngIf="showExcelButton"
			mat-icon-button
			matTooltip="Export to Excel"
			(click)="onExcelExport()"
			[disabled]="excelDisabled">
			<img src="assets/images/icons/xcel-icon-24px.png"  alt="Export to Excel" class="excel-icon"/>
		</button>

		<!-- Global Search -->
		<div class="global-search-wrapper" *ngIf="showGlobalSearch">
			<img src="assets/images/icons/Search-2 .png"  alt="Search" class="global-search-icon" />
			<input type="text" class="global-search-input"
				[placeholder]="searchPlaceholder"
				[value]="searchText"
				(input)="onSearchInput($any($event.target).value)"
				(keydown.escape)="clearSearch()" />
			<span class="global-search-count" *ngIf="searchText && searchMatchCount > 0">
				{{ searchMatchCount }} found
			</span>
			<button mat-icon-button class="global-search-clear" *ngIf="searchText"
				(click)="clearSearch()" matTooltip="Clear search">
				<mat-icon>close</mat-icon>
			</button>
		</div>

		
        <!-- Filter Toggle Button -->
        <button *ngIf="showFilterToggle"
            mat-button
            matTooltip="Filters"
            class="filter-toggle-btn"
            [class.active]="filterPanelOpen"
            (click)="onFilterToggle()">
            <div style="display: flex; align-items: center; gap: 4px;">
                <img src="assets/images/icons/Funnel.png" width="20" height="20" alt="Filter" />
                <span class="filter-btn-text">Filters</span>
            </div>
        </button>


		<!-- Extra projected content (custom buttons) -->
		<ng-content></ng-content>
	</div>
</div>
